'use strict';

var $ = require('jquery');
var config = require('../../js/config');

var CountriesAndStatesAPI = function() {
};

CountriesAndStatesAPI.prototype.getCountriesAndStates = function() {
  return $.ajax({
    type: 'GET',
    url: config.urls.cartPromotion.getCountries
  }).then(function(response) {
    if (response.data) {
      return response.data.countries;
    }
    return false;
  });
};

CountriesAndStatesAPI.prototype.getCmsCountriesAndStates = function() {
  return $.ajax({
    type: 'GET',
    url: config.urls.cms.getCmsCountriesAndStates
  }).then(function(response) {
    if (response.data) {
      return response.data.countries;
    }
    return false;
  });
};

module.exports = new CountriesAndStatesAPI();



// WEBPACK FOOTER //
// ./assets/components/CountriesAndStates/CountriesAndStatesAPI.js